/**
 * Selects sanitized pilot HTML when the build has produced it, including an intentionally empty result.
 * Legacy descriptions remain available only for products without a sanitized field.
 *
 * @param {{ description?: string; safeDescriptionHtml?: string }} tour
 * @returns {string}
 */
export function selectTourDescriptionHtml(tour) {
	return tour.safeDescriptionHtml ?? tour.description ?? '';
}
